<template>
  <div class="bundle-prices">
    <div class="bundle-price">
      <span class="bundle-price__label">정가</span>
      <span class="bundle-price__amount del">{{ listPrice | numeric }}원</span>
    </div>
    <div class="bundle-price">
      <span class="bundle-price__label">할인 판매가</span>
      <span>
        <span class="bundle-price__discount">{{ discount }}% 할인</span>
        <span class="bundle-price__amount">{{ salePrice | numeric }}원</span>
      </span>
    </div>
    <div class="bundle-price">
      <span class="bundle-price__label normal">12개월 할부</span>
      <span class="bundle-price__amount emphasis">월 {{ monthlyPrice | numeric }} 원</span>
    </div>
  </div>
</template>

<script>
export default {
  props: ['listPrice', 'salePrice', 'discountAmount'],
  computed: {
    monthlyPrice() {
      return Math.round((this.salePrice * 1) / 12);
    },
    discount() {
      return Math.ceil(((this.listPrice - this.salePrice) / this.listPrice) * 100);
    },
  },
};
</script>
